import clsx from 'clsx';
import React from 'react';

interface OptionSelectorProps<T> {
  options: T[];
  selected: T | null;
  allOption?: {
    label: React.ReactNode;
    value: T | null;
  };
  onSelect: (value: T | null) => void;
  renderLabel: (value: T) => React.ReactNode;
  className?: string;
}

export function OptionSelector<T extends string | number>({
  options,
  selected,
  allOption,
  onSelect,
  renderLabel,
  className = '',
}: Readonly<OptionSelectorProps<T>>) {
  return (
    <div
      className={clsx(
        `custom-scrollbar max-w-[85vw] overflow-x-auto whitespace-nowrap flex gap-2`,
        className
      )}
    >
      {allOption && (
        <button
          onClick={() => onSelect(allOption.value)}
          className={`px-4 py-2 rounded-lg whitespace-nowrap ${
            selected === allOption.value
              ? 'bg-wl-on-surface text-wl-surface text-R-16'
              : 'bg-wl-surface text-wl-on-surface opacity-50  text-M-16'
          }`}
        >
          {allOption.label}
        </button>
      )}
      {options.map((option) => (
        <button
          key={option}
          onClick={() => onSelect(option)}
          className={`px-4 py-2 rounded-md whitespace-nowrap ${
            selected === option
              ? 'bg-wl-on-surface text-wl-surface text-R-16'
              : 'bg-wl-surface text-wl-on-surface text-M-16'
          }`}
        >
          <span className={`${selected === option ? '' : 'opacity-50'}`}>
            {renderLabel(option)}
          </span>
        </button>
      ))}
    </div>
  );
}
